import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarData = [
  {
    title: 'Dashboard',
    path: '/Dashboard',
    // icon: <AiIcons.AiFillHome />,
    icon: "	fas fa-desktop",
    cName: 'nav-text'
  },
  
  {
    title: 'Aprooval',
    path: '/requestforaprooval',
    icon: "	far fa-edit",
    cName: 'nav-text'
  },
  {
    title: 'Assign Drivers',
    path: '/assigndrivers',
    icon: "		fas fa-walking",
    cName: 'nav-text'
  },
  {
    title: 'Emergency Request',
    path: '/emergencyrequest',
    icon: "	fas fa-fire",
    cName: 'nav-text'
  },
  {
    title: 'Shedule Drivers',
    path: '/rostermanagement',
    icon: "	fas fa-bus-alt",
    cName: 'nav-text'
  },

  {
    title: 'Shedules For Drivers',
    path: '/displayshedule',
    icon: "	fas fa-paper-plane",
    cName: 'nav-text'
  },

  {
    title: 'Assign company',
    path: '/retreivedrivers',
    icon: "		fas fa-clipboard-list",
    cName: 'nav-text'
  },

  

];
